import {fetchBuildsData} from '../../../../../actions/builds'
import type {AppThunk} from '../../../../../actions/types'
import type {Refetchable} from '../../../../../utils/refetchable'

import {getLastDeployedBuildLocator} from './Deployments.rest'
import type {LastDeployedBuildConfig} from './Deployments.types'

export const fetchLastDeployedBuild = (config: LastDeployedBuildConfig): AppThunk<Refetchable> =>
  fetchBuildsData({
    locator: getLastDeployedBuildLocator(config),
    requestOptions: {
      withQueuedInfo: true,
    },
  })
